import * as React from 'react'

export function Empty(props: React.Props<any>): JSX.Element {
    return (<div/>)
}